export default "__VITE_ASSET__CbZGXl6d__"